import React from 'react';
import FeatherIcon from 'feather-icons-react';
import { urgencyColors } from '../../../constants/utils';
import { useTranslation } from 'react-i18next';

/**
 * Shared component for priority/urgency display
 *
 * @param {string} priority - Priority value (HIGH, MEDIUM, LOW, SEVERE, NONE)
 * @param {boolean} showIcon - Show icon (default: false)
 * @param {boolean} uppercase - Uppercase label (default: true)
 * @param {string} className - Additional CSS classes
 */
const PriorityBadge = ({
  priority,
  showIcon = false,
  uppercase = true,
  className = '',
}) => {
  const { t } = useTranslation();
  const colorClass = urgencyColors[priority] || urgencyColors.NONE || 'bg-secondary';

  const priorityIcons = {
    SEVERE: 'alert-octagon',
    HIGH: 'alert-triangle',
    MEDIUM: 'alert-circle',
    LOW: 'check-circle',
    NONE: 'minus-circle',
  };

  const icon = priorityIcons[priority] || 'minus-circle';
  const label = priority ? t(`shared.${priority.toLowerCase()}`, priority) : t('shared.n_a', 'N/A');
  const displayLabel = uppercase ? label.toUpperCase() : label;

  return (
    <span className={`badge rounded-pill py-1 px-2 d-inline-flex align-items-center gap-1 ${colorClass} ${className}`}>
      {showIcon && <FeatherIcon icon={icon} size={12} />}
      {displayLabel}
    </span>
  );
};

export default PriorityBadge;
